export const FETCH_SEHIRLER = 'FETCH_SEHIRLER';
export const FETCH_PARA_BIRIMLERI = 'FETCH_PARA_BIRIMLERI';
export const FETCH_CARI_LISTESI = 'FETCH_CARI_LISTESI';
export const FETCH_STOK_LISTESI = 'FETCH_STOK_LISTESI';
export const FETCH_HIZMET_LISTESI = 'FETCH_HIZMET_LISTESI';
export const FETCH_DEPO_LISTESI = 'FETCH_DEPO_LISTESI';
export const FETCH_KASA_LISTESI = 'FETCH_KASA_LISTESI';
export const OTHERS_FETCH_API_SUCCESS = 'OTHERS_FETCH_API_SUCCESS';
export const API_FAILED = 'OTHERS_API_FAILED';
